import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { TrackObject } from '../asp/TrackObject';
import * as aro from '@core_n/aro/aro';

const REFRESH_CORR_PLOTS_RATE = 5; // once every 5 refresh cycles

@Component({
  templateUrl: 'aro-track-tab-classification.component.html',
  styleUrls: ['../../core/app/aro/aro.component.scss']
})
export class AroTrackTabClassificationComponent implements OnInit {

  public systemClass: number = 0;
  public operatorClass: number = 0;
  public fighter: number = 0;
  public helicopter: number = 0;
  public subsonicMissile: number = 0;
  public supersonicMissile: number = 0;
  public transporter: number = 0;
  public uav: number = 0;

  constructor() { }

  ngOnInit(): void {
  }

  refresh(track: TrackObject): void {
    // this.systemClass = track.systemClass;
    // this.operatorClass = track.operatorClass;
    // this.fighter = track.idfFighter;
    // this.helicopter = track.idfHelicopter;
    // this.subsonicMissile = track.idfSubsonicMissile;
    // this.supersonicMissile = track.idfSupersonicMissile;
    // this.transporter = track.idfTransporter;
    // this.uav = track.idfUav;
  }

}
